module.exports.outsideClick = function (selector, event) {
	const $target = $(event.target);
	if (!$target.closest(selector).length && $(selector).is(':visible')) {
		return true;
	}
	return false;
};
